"use client";
import Link from "next/link";
import { Colors } from "@/shared/constants";
import { twMerge } from "tailwind-merge";
import ImageIcon from "@/assets/icons/image.svg";
import { UserLink } from "../../User/UserLink";
import { ShortUser } from "@/api/users/types";
import { getUsersName } from "@/api/users/helpers";
import { EndemicImage } from "@/app/(components)/Basic/Image";
import { ImagePlaceholder } from "@/app/(components)/Basic/Image/types";
import { EndemicUserWrapper } from "@/app/(components)/Basic/EndemicUserWrapper";
import DefaultCollectionImage from "@/assets/graphics/default-collection-image.svg?url";
export interface Props {
  imageSrc: string;
  imagePlaceholder?: ImagePlaceholder;
  href: string;
  title: string;
  titleColor: Colors;
  artist: ShortUser;
  description: string;
  swap: boolean;
  className?: string;
  collectionCount?: number;
}

const CollectionItem = ({
  title,
  artist,
  imageSrc,
  imagePlaceholder,
  href,
  description,
  titleColor,
  swap,
  className,
  collectionCount,
}: Props) => {
  return (
    <div
      className={twMerge(
        "flex flex-col justify-center align-middle lg:flex-row md:items-center gap-x-10 gap-y-2 mb-20 lg:w-full lg:max-w-full mx-auto",
        swap ? "flex-col-reverse" : "flex-col",
        className,
      )}
    >
      <Link
        href={href}
        className={twMerge(
          "block basis-1/2 w-[320px] lg:max-w-[400px] m-auto md:m-0 mb-4 lg:mb-0",
          swap && "order-1",
        )}
      >
        <EndemicImage
          src={imageSrc || DefaultCollectionImage.src}
          displayDefaultPlaceholder
          placeholder={imagePlaceholder}
          alt={title}
          width={400}
          height={400}
          className="w-[320px] h-[320px] lg:w-[400px] lg:h-[400px] object-cover"
          aspectRatio
        />
        {collectionCount && (
          <div className="absolute flex bg-[rgba(0,0,0,0.75)] rounded-3xl p-2 px-4 top-3 left-3 text-white">
            <ImageIcon width="16px" fill="white" className="mr-2" />{" "}
            {collectionCount} {collectionCount > 1 ? "items" : "item"}
          </div>
        )}
      </Link>

      <div
        className={twMerge(
          "flex m-auto md:m-0 flex-col w-full max-w-[320px] lg:basis-1/2 lg:max-w-[400px] items-start",
        )}
      >
        <Link href={href}>
          <h1
            className={twMerge("font-semibold", `gradient text-${titleColor}`)}
          >
            {title}
          </h1>
        </Link>
        <UserLink artist={artist} tooltipPosition={["center", "bottom"]}>
          <span className="text-secondary text-body-3 mt-2 md:mt-3 mb-2 md:mb-5">
            <EndemicUserWrapper id={artist.id}>
              by {getUsersName(artist, true)}
            </EndemicUserWrapper>
          </span>
        </UserLink>
        <div className="text-body-2">{description}</div>
      </div>
    </div>
  );
};

export default CollectionItem;
